export default "__VITE_ASSET__lokvT$ae__"